import React, { useCallback } from 'react';
import usePipelineCreationContext from '../PipelineCreationContext';

import Button from '../../common/Button/Button';
import CardView from '../../common/CardView/CardView';
import Label from '../../common/Labels/Label';

import PipelineStepListContent from '../PipelineStepList/PipelineStepListContent';

export const PipelineConfirmCreationFrame = ({
  pipelineName,
  pipelineSteps,
  build,
  handleBack, 
  handleGoToAddSteps, 
  onClose,
  onDeleteStep,
  cardTitle,
}) => {
  const onBuild = useCallback(async () => {
    await build(pipelineSteps);
    onClose();
  }, [build, pipelineSteps, onClose])

  return (
    <CardView className="flex flex-col">
      <div className="flex justify-between items-center mb-2">
        <Label size="lg" bold>{cardTitle}</Label>
        <Button
          variant="close"
          iconSize={24}
          textColor="border-dark"
          hoverTextColor="border-darker"
          activeTextColor="info"
          onClick={onClose}
        />
      </div>
      <Label bold className="underline">{pipelineName}</Label>
      <div className="my-2">
        {
          pipelineSteps?.length ? (
            <PipelineStepListContent items={pipelineSteps} onDeleteStep={onDeleteStep} />
          ) : <Label>No Steps Specified for this pipeline</Label>
        }
      </div>
      <div className="w-full flex justify-between my-2">
        <Button onClick={handleBack} size="large">Back</Button>
        <div className="flex justify-end">
          <Button size="large" onClick={handleGoToAddSteps}>Add Step(s)</Button>
          <Button
            className="ml-2"
            variant="primary"
            size="large"
            disabled={!pipelineName?.length || !pipelineSteps?.length}
            onClick={onBuild}
          >
            Build
          </Button>
        </div>
      </div>
    </CardView>
  )
}

const ContextualCreationFrame = ({
  handleBack, handleGoToAddSteps, onClose, cardTitle
}) => {
  const {
    pipelineName,
    pipelineSteps,
    build,
    removeStep,
  } = usePipelineCreationContext();
  
  return (
    <PipelineConfirmCreationFrame 
      pipelineName={pipelineName}
      pipelineSteps={pipelineSteps}
      build={build}
      handleBack={handleBack}
      handleGoToAddSteps={handleGoToAddSteps}
      onClose={onClose}
      onDeleteStep={removeStep}
      cardTitle={cardTitle}
    />
  )
}

export default ContextualCreationFrame;
